import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IChangeFlightStatusRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type IChangeFlightStatusRepo = IRepo<[id: number | string, statusId: number | string], IChangeFlightStatusRepoResponse>;

export const ChangeFlightStatusRepoType = Symbol.for('ChangeFlightStatusRepoType');

@bind(ChangeFlightStatusRepoType)
export class ChangeFlightStatusRepo implements IChangeFlightStatusRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string, state_id: number | string) {
    try {
      const body = new FormData();

      appendToFormData({ flight_id: id }, body);

      const url = urlMaker('/api/admin/flights/state_change', { state_id });

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 422 || result.status === 400) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
